import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IRezervasyonForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IRezervasyonForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  RezervasyonKaydet: any;
  RezervasyonKaydet_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  AddToBag: boolean;
  AddToBag_dummy: boolean;
  GetFromBag_GIDISREZID: Guid;
  GetFromBag_GIDISREZID_dummy: Guid;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  RezervasyonGorunumAyarla: any;
  RezervasyonGorunumAyarla_dummy: any;
  TalepEdenListeGetir: any[];
  TalepEdenListeGetir_dummy: any[];
  GetYetki: any;
  GetYetki_dummy: any;
  YeniGuid: any[];
  YeniGuid_dummy: any[];
  OnayDurumListe: any[];
  OnayDurumListe_dummy: any[];
  MurettebatListe: any[];
  MurettebatListe_dummy: any[];
  UcakListe: any[];
  UcakListe_dummy: any[];
  UcusTipiListe: any[];
  UcusTipiListe_dummy: any[];
  RezervasyonGetir: any[];
  RezervasyonGetir_dummy: any[];
  RezervasyonDefaultGetir: any;
  RezervasyonDefaultGetir_dummy: any;
  UlkeListe: any[];
  UlkeListe_dummy: any[];
  YolcuTmpYarat: number;
  YolcuTmpYarat_dummy: number;
  YolcuTmpListe: any[];
  YolcuTmpListe_dummy: any[];
  IptalYetki: boolean;
  IptalYetki_dummy: boolean;
  YazismaGetir: any[];
  YazismaGetir_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  NoktaListe: any[];
  NoktaListe_dummy: any[];
  VarisNoktaListe: any[];
  VarisNoktaListe_dummy: any[];
  SunriseSunsetGetir: any;
  SunriseSunsetGetir_dummy: any;
  YolcuTmpAdet: any[];
  YolcuTmpAdet_dummy: any[];
  YolcuTmpAdSoyadlar: any[];
  YolcuTmpAdSoyadlar_dummy: any[];
  YolcuTmpSil: number;
  YolcuTmpSil_dummy: number;
  YazismaEkle: string;
  YazismaEkle_dummy: string;
  isComp432393Visible: "visible" | "hidden";
  isComp162835Visible: "visible" | "hidden";
  isComp794779Visible: "visible" | "hidden";
  isComp940133Visible: "visible" | "hidden";
  isComp448448Visible: "visible" | "hidden";
  isComp388008Visible: "visible" | "hidden";
  isComp242250Visible: "visible" | "hidden";
  isComp95703Visible: "visible" | "hidden";
  isComp172569Visible: "visible" | "hidden";
  isComp211788Visible: "visible" | "hidden";
  isComp808539Visible: "visible" | "hidden";
  isComp506865Visible: "visible" | "hidden";
  isComp949529Visible: "visible" | "hidden";
  isComp24225Visible: "visible" | "hidden";
  isComp422516Visible: "visible" | "hidden";
  isComp385661Visible: "visible" | "hidden";
  isComp249814Visible: "visible" | "hidden";
  isComp907296Visible: "visible" | "hidden";
  isComp190170Visible: "visible" | "hidden";
  isComp825552Visible: "visible" | "hidden";
  isComp989587Visible: "visible" | "hidden";
  isComp107260Visible: "visible" | "hidden";
  isComp792446Visible: "visible" | "hidden";
  isComp11679Visible: "visible" | "hidden";
  isComp575039Visible: "visible" | "hidden";
  isComp641052Visible: "visible" | "hidden";
  isComp607211Visible: "visible" | "hidden";
  isComp100817Visible: "visible" | "hidden";
  isComp127384Visible: "visible" | "hidden";
  isComp938114Visible: "visible" | "hidden";
  isComp167272Visible: "visible" | "hidden";
  isComp203119Visible: "visible" | "hidden";
  isComp848871Visible: "visible" | "hidden";
  isComp808818Visible: "visible" | "hidden";
  isComp354518Visible: "visible" | "hidden";
  isComp141226Visible: "visible" | "hidden";
  isComp510322Enabled: "enabled" | "disabled";
  isComp322266Enabled: "enabled" | "disabled";
  isComp577867Enabled: "enabled" | "disabled";
  isComp769408Enabled: "enabled" | "disabled";
  isComp907296Enabled: "enabled" | "disabled";
  isComp825552Enabled: "enabled" | "disabled";
  isComp989587Enabled: "enabled" | "disabled";
  isComp863315Enabled: "enabled" | "disabled";
  isComp458347Enabled: "enabled" | "disabled";
  isComp844446Enabled: "enabled" | "disabled";
  isComp792446Enabled: "enabled" | "disabled";
  isComp682208Enabled: "enabled" | "disabled";
  isComp891227Enabled: "enabled" | "disabled";
  isComprezervasyonform_346824AuthorizationVisible: "visible" | "hidden";
  isComprezervasyonform_316044AuthorizationEnabled: "enabled" | "disabled";
}

export class RezervasyonForm_ScreenBase extends React.PureComponent<
  IRezervasyonForm_ScreenProps,
  any
> {
  rezervasyonform_322266_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonform_577867_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonform_316044_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonform_167735_value_kuikaAutoCompleteRef: React.RefObject<any>;
  rezervasyonform_459685_value_kuikaAutoCompleteRef: React.RefObject<any>;
  rezervasyonform_284227_value_kuikaAutoCompleteRef: React.RefObject<any>;
  rezervasyonform_554090_value_kuikaAutoCompleteRef: React.RefObject<any>;
  rezervasyonform_461957_value_kuikaDateRef: React.RefObject<any>;
  rezervasyonform_445833_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_863315_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_458347_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_844446_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_682208_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_891227_value_kuikaDatetimeRef: React.RefObject<any>;
  rezervasyonform_990298_value_kuikaTableRef: React.RefObject<any>;
  rezervasyonform_412266_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "e6d0b274-b684-4446-a221-7c06bbd54552",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 854746, PropertyName: "label", Value: "Vazgeç" },
        { Id: 162835, PropertyName: "label", Value: "Kaydet C#" },
        { Id: 794779, PropertyName: "label", Value: "Taslak Kaydet" },
        { Id: 940133, PropertyName: "label", Value: "Tamamla" },
        { Id: 448448, PropertyName: "label", Value: "Güncelle" },
        { Id: 388008, PropertyName: "label", Value: "Onayla" },
        { Id: 242250, PropertyName: "label", Value: "Reddet" },
        { Id: 95703, PropertyName: "label", Value: "İptal Et" },
        { Id: 172569, PropertyName: "label", Value: "Sil" },
        { Id: 211788, PropertyName: "label", Value: "Donus" },
        { Id: 972475, PropertyName: "value", Value: "Rezervasyon Kaydı" },
        { Id: 808539, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 506865, PropertyName: "placeholder", Value: "User Role Names" },
        { Id: 949529, PropertyName: "label", Value: "Ucuş Müdürü" },
        { Id: 24225, PropertyName: "label", Value: "Yönetici Asistanı" },
        { Id: 422516, PropertyName: "label", Value: "Teknisyen" },
        { Id: 385661, PropertyName: "label", Value: "Yolcu" },
        { Id: 249814, PropertyName: "label", Value: "Pilot" },
        { Id: 3760, PropertyName: "label", Value: "Tarihçe" },
        { Id: 860329, PropertyName: "value", Value: "Rezervasyon No" },
        {
          Id: 510322,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 70519, PropertyName: "value", Value: "Durum" },
        { Id: 322266, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 356931, PropertyName: "value", Value: "Talep Eden" },
        { Id: 577867, PropertyName: "placeholder", Value: "Seçiniz..." },
        { Id: 7557, PropertyName: "value", Value: "Uçuş Tipi" },
        { Id: 316044, PropertyName: "placeholder", Value: "Choose one..." },
        {
          Id: 432393,
          PropertyName: "value",
          Value:
            "* Kaydettikten sonra dönüş rezervasyonu ekranına yönlendirileceksiniz...",
        },
        { Id: 907296, PropertyName: "value", Value: "Gidiş Rezervasyon No" },
        { Id: 190170, PropertyName: "value", Value: "Dönüş Rezervasyon No" },
        { Id: 825552, PropertyName: "placeholder", Value: "0" },
        { Id: 989587, PropertyName: "placeholder", Value: "0" },
        { Id: 969375, PropertyName: "value", Value: "Kalkış Noktası" },
        { Id: 167735, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 459685, PropertyName: "placeholder", Value: "Search..." },
        { Id: 520444, PropertyName: "value", Value: "Varış Noktası" },
        { Id: 284227, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 554090, PropertyName: "placeholder", Value: "Search..." },
        { Id: 497421, PropertyName: "value", Value: "Kalkış Tarihi" },
        { Id: 461957, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 617128, PropertyName: "value", Value: "Kalkış Saati" },
        { Id: 445833, PropertyName: "placeholder", Value: "Saat seçiniz..." },
        { Id: 287522, PropertyName: "value", Value: "Kalkış Gün Doğumu" },
        {
          Id: 863315,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 394186, PropertyName: "value", Value: "Kalkış Gün Batımı" },
        {
          Id: 458347,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 41908, PropertyName: "value", Value: "Varış Saati" },
        {
          Id: 844446,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 792446, PropertyName: "placeholder", Value: "Onaylayan" },
        { Id: 696306, PropertyName: "value", Value: "Varış Gün Doğumu" },
        {
          Id: 682208,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 18581, PropertyName: "value", Value: "Varış Gün Batımı" },
        {
          Id: 891227,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 838670, PropertyName: "value", Value: "Yolcular" },
        { Id: 575039, PropertyName: "placeholder", Value: "33.45" },
        { Id: 641052, PropertyName: "label", Value: "Ekle" },
        {
          Id: 990298,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz yolcu yok...",
        },
        { Id: 489617, PropertyName: "title", Value: "Kayıtlı/Kayıtsız" },
        { Id: 607211, PropertyName: "value", Value: "Kayıtlı" },
        { Id: 100817, PropertyName: "value", Value: "Kayıtsız" },
        { Id: 937170, PropertyName: "title", Value: "Ad Soyad" },
        { Id: 707202, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 128889, PropertyName: "title", Value: "Ağılık (Kg)" },
        { Id: 370804, PropertyName: "value", Value: "[datafield:agirlik]" },
        { Id: 474346, PropertyName: "title", Value: "Bagaj Adet" },
        { Id: 292751, PropertyName: "value", Value: "[datafield:bagajadet]" },
        { Id: 382877, PropertyName: "title", Value: "Bagaj Ağırlık (Kg)" },
        {
          Id: 625246,
          PropertyName: "value",
          Value: "[datafield:bagajagirlik]",
        },
        { Id: 252521, PropertyName: "title", Value: "İşlem" },
        { Id: 385903, PropertyName: "value", Value: "Mürettebat" },
        { Id: 316139, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 308589, PropertyName: "value", Value: "Yazışma" },
        {
          Id: 412266,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz yolcu yok...",
        },
        { Id: 777940, PropertyName: "title", Value: "Yazışma" },
        { Id: 296137, PropertyName: "value", Value: "[datafield:metin]" },
        { Id: 565085, PropertyName: "value", Value: "[datafield:talepeden]" },
        {
          Id: 987221,
          PropertyName: "value",
          Value: "[datafield:talepedenzaman]",
        },
        { Id: 54829, PropertyName: "value", Value: "[datafield:metin]" },
        {
          Id: 487355,
          PropertyName: "value",
          Value: "[datafield:onaylayanzaman]",
        },
        { Id: 132389, PropertyName: "value", Value: "[datafield:onaylayan]" },
        {
          Id: 755702,
          PropertyName: "placeholder",
          Value: "Bir mesaj yazın ...",
        },
        { Id: 631587, PropertyName: "label", Value: "Gönder" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.rezervasyonform_808539_value_kuikaTextInputRef = React.createRef();
    this.rezervasyonform_506865_value_kuikaTextInputRef = React.createRef();
    this.rezervasyonform_510322_value_kuikaTextInputRef = React.createRef();
    this.rezervasyonform_322266_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonform_577867_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonform_316044_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonform_167735_value_kuikaAutoCompleteRef = React.createRef();
    this.rezervasyonform_459685_value_kuikaAutoCompleteRef = React.createRef();
    this.rezervasyonform_284227_value_kuikaAutoCompleteRef = React.createRef();
    this.rezervasyonform_554090_value_kuikaAutoCompleteRef = React.createRef();
    this.rezervasyonform_461957_value_kuikaDateRef = React.createRef();
    this.rezervasyonform_445833_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_863315_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_458347_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_844446_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_792446_value_kuikaTextInputRef = React.createRef();
    this.rezervasyonform_682208_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_891227_value_kuikaDatetimeRef = React.createRef();
    this.rezervasyonform_990298_value_kuikaTableRef = React.createRef();
    this.rezervasyonform_412266_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      RezervasyonKaydet: "",
      IfThenElse: false,
      TriggerEvent: "",
      SetValueOf: "",
      RezervasyonGorunumAyarla: "",
      TalepEdenListeGetir: [],
      GetYetki: "",
      YeniGuid: [],
      OnayDurumListe: [],
      MurettebatListe: [],
      UcakListe: [],
      UcusTipiListe: [],
      RezervasyonGetir: [],
      UlkeListe: [],
      YolcuTmpListe: [],
      IptalYetki: false,
      YazismaGetir: [],
      ChangeVisibilityOf: "",
      NoktaListe: [],
      VarisNoktaListe: [],
      SunriseSunsetGetir: "",
      YolcuTmpAdet: [],
      YolcuTmpAdSoyadlar: [],
      YolcuTmpSil: 0,
      YazismaEkle: "",
      dataSource_769408: [
        { key: "0", text: "Tek Yön" },
        { key: "1", text: "Gidiş Dönüş" },
      ],
      isComp432393Visible: "hidden",
      isComp162835Visible: "hidden",
      isComp794779Visible: "hidden",
      isComp940133Visible: "hidden",
      isComp448448Visible: "hidden",
      isComp388008Visible: "hidden",
      isComp242250Visible: "hidden",
      isComp95703Visible: "hidden",
      isComp172569Visible: "hidden",
      isComp211788Visible: "hidden",
      isComp808539Visible: "hidden",
      isComp506865Visible: "hidden",
      isComp949529Visible: "hidden",
      isComp24225Visible: "hidden",
      isComp422516Visible: "hidden",
      isComp385661Visible: "hidden",
      isComp249814Visible: "hidden",
      isComp907296Visible: "hidden",
      isComp190170Visible: "hidden",
      isComp825552Visible: "hidden",
      isComp989587Visible: "hidden",
      isComp107260Visible: "hidden",
      isComp792446Visible: "hidden",
      isComp11679Visible: "hidden",
      isComp575039Visible: "hidden",
      isComp641052Visible: "hidden",
      isComp607211Visible: "hidden",
      isComp100817Visible: "hidden",
      isComp127384Visible: "hidden",
      isComp938114Visible: "hidden",
      isComp167272Visible: "hidden",
      isComp203119Visible: "hidden",
      isComp848871Visible: "hidden",
      isComp808818Visible: "hidden",
      isComp354518Visible: "hidden",
      isComp141226Visible: "hidden",
      isComp510322Enabled: "disabled",
      isComp322266Enabled: "disabled",
      isComp577867Enabled: "disabled",
      isComp769408Enabled: "disabled",
      isComp907296Enabled: "disabled",
      isComp825552Enabled: "disabled",
      isComp989587Enabled: "disabled",
      isComp863315Enabled: "disabled",
      isComp458347Enabled: "disabled",
      isComp844446Enabled: "disabled",
      isComp792446Enabled: "disabled",
      isComp682208Enabled: "disabled",
      isComp891227Enabled: "disabled",
      isComprezervasyonform_346824AuthorizationVisible: "visible",
      isComprezervasyonform_316044AuthorizationEnabled: "enabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("rezervasyonform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.RezervasyonFormPageInit();
    }
    ReactSystemFunctions.disableIsNotAuthorized(
      this,
      "isComprezervasyonform_316044AuthorizationEnabled",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComprezervasyonform_346824AuthorizationVisible",
      []
    );

    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYYOLCU",
      "FLYASISTAN",
      "FLYPILOT",
      "FLYTEKNISYEN",
      "FLYMALIISLER",
      "FLYADMIN",
      "FLYORTAK",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.RezervasyonFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      rezervasyonform_949529_checked: this.state.GetYetki?.mudur ?? undefined,
      rezervasyonform_24225_checked: this.state.GetYetki?.asistan ?? undefined,
      rezervasyonform_422516_checked:
        this.state.GetYetki?.teknisyen ?? undefined,
      rezervasyonform_385661_checked: this.state.GetYetki?.yolcu ?? undefined,
      rezervasyonform_249814_checked: this.state.GetYetki?.pilot ?? undefined,
      rezervasyonform_825552_value: undefined,
      rezervasyonform_989587_value: undefined,
      rezervasyonform_575039_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  RezervasyonFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CrudMode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "number"
      ),
      IsDonus_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        "boolean"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      RezervasyonId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CrudMode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonGorunumAyarla = result?.data.rezervasyonGorunumAyarla;
    stateVars.isComp794779Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.taslakKaydet
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp940133Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.tamamla
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp448448Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.guncelle
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp388008Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.onayla
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp242250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.reddet
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp95703Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.iptal
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp172569Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.sil
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp107260Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.varisSaatVisible
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp641052Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp127384Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp938114Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp141226Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.gonder
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp577867Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGorunumAyarla?.talepEden
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.TalepEdenListeGetir = result?.data.talepEdenListeGetir;

    formVars.rezervasyonform_577867_options = stateVars.TalepEdenListeGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_506865_value",
        "string"
      ),
      ReactSystemFunctions.getMyRoleNames(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      yetkiStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_506865_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetYetki = result?.data.getYetki;
    formVars.rezervasyonform_949529_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.mudur
    );
    formVars.rezervasyonform_24225_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.asistan
    );
    formVars.rezervasyonform_422516_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.teknisyen
    );
    formVars.rezervasyonform_385661_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.yolcu
    );
    formVars.rezervasyonform_249814_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.pilot
    );
    stateVars.YeniGuid = result?.data.yeniGuid;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_808539_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.YeniGuid !== undefined
          ? stateVars.YeniGuid?.length > 0
            ? stateVars.YeniGuid[0].newguid
            : null
          : this.state.YeniGuid?.length > 0
          ? this.state.YeniGuid[0].newguid
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumListe = result?.data.onayDurumListe;

    formVars.rezervasyonform_322266_options = stateVars.OnayDurumListe;
    stateVars.MurettebatListe = result?.data.murettebatListe;

    formVars.rezervasyonform_316139_options = stateVars.MurettebatListe;
    stateVars.UcakListe = result?.data.ucakListe;
    stateVars.UcusTipiListe = result?.data.ucusTipiListe;

    formVars.rezervasyonform_316044_options = stateVars.UcusTipiListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      IsDonus_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        "boolean"
      ),
      OrjId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.OrjId ?? this.props.screenInputs.orjid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit5_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonGetir = result?.data.rezervasyonGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit6_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if6 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit_if6",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonDefaultGetir = result?.data.rezervasyonDefaultGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if61_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if61_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_167735_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("TR", "string"),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_167735_onChange) {
      {
        await this.RezervasyonFormComponent_167735_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_459685_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("LTFB", "string"),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_284227_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("TR", "string"),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_284227_onChange) {
      {
        await this.RezervasyonFormComponent_284227_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_577867_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        this.state.RezervasyonDefaultGetir?.talepEden
      ),
      null,
      "Eposta"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_461957_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        this.state.RezervasyonDefaultGetir?.kalkisTarih
      ),
      null,
      true
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_461957_onChange) {
      {
        await this.RezervasyonFormComponent_461957_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_445833_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        this.state.RezervasyonDefaultGetir?.kalkisSaat
      ),
      null,
      true
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_445833_onChange) {
      {
        await this.RezervasyonFormComponent_445833_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_769408_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_316044_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "No"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonFormPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      )
    ) {
      isErrorOccurred = await this.RezervasyonFormPageInit_if6();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit7_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit7_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UlkeListe = result?.data.ulkeListe;

    formVars.rezervasyonform_167735_options = stateVars.UlkeListe;

    formVars.rezervasyonform_284227_options = stateVars.UlkeListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit8_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if8 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      IsDonus_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        "boolean"
      ),
      OrjId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.OrjId ?? this.props.screenInputs.orjid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit_if8",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonGetir = result?.data.rezervasyonGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if81_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if81_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_510322_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].rezervasyonNo
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].rezervasyonNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_322266_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].onayDurumu
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].onayDurumu
          : null
      ),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_316044_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].ucusTipi
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].ucusTipi
          : null
      ),
      null,
      "No"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if82_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if82_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_167735_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisUlke
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_167735_onChange) {
      {
        await this.RezervasyonFormComponent_167735_onChange();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if83_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if83_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_459685_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisNokta
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisNokta
          : null
      ),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_461957_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisTarih
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisTarih
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_445833_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisSaat
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisSaat
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_863315_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisGunDogumu
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisGunDogumu
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_458347_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].kalkisGunBatimi
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].kalkisGunBatimi
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if84_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if84_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_284227_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].varisUlke
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].varisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.RezervasyonFormComponent_284227_onChange) {
      {
        await this.RezervasyonFormComponent_284227_onChange();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if85_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if85_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_554090_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].varisNokta
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].varisNokta
          : null
      ),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_844446_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].varisSaat
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].varisSaat
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_682208_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].varisGunDogumu
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].varisGunDogumu
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_891227_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].varisGunBatimi
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].varisGunBatimi
          : null
      ),
      null,
      ""
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if86_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if86_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_577867_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].talepEden
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].talepEden
          : null
      ),
      null,
      "Eposta"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if87_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if87_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_316139_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].murettebat
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].murettebat
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if88_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if88_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].yolcuAdet
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].yolcuAdet
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_792446_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].onaylayan
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].onaylayan
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_769408_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].tekYonGidisDonus
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].tekYonGidisDonus
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_989587_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].donusRezervasyonNo
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].donusRezervasyonNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_825552_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetir !== undefined
          ? stateVars.RezervasyonGetir?.length > 0
            ? stateVars.RezervasyonGetir[0].gidisRezervasyonNo
            : null
          : this.state.RezervasyonGetir?.length > 0
          ? this.state.RezervasyonGetir[0].gidisRezervasyonNo
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit_if89_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if8f9 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      GrupId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.OrjId ?? this.props.screenInputs.orjid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit_if8f9",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpYarat = result?.data.yolcuTmpYarat;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  RezervasyonFormPageInit_if8e9 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      GrupId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit_if8e9",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpYarat = result?.data.yolcuTmpYarat;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  RezervasyonFormPageInit_if89_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      isErrorOccurred = await this.RezervasyonFormPageInit_if8f9();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.RezervasyonFormPageInit_if8e9();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonFormPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) ||
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      isErrorOccurred = await this.RezervasyonFormPageInit_if8();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit9_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormPageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit9_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit10_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Yolcu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_385661_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Pilot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      OnayDurum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_322266_value",
            "value",
            "OnayDurumListe",
            "durum",
            "durum"
          )
        ),
        "number"
      ),
      IsDonus_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        "boolean"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit10_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IptalYetki = result?.data.iptalYetki;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormPageInit11_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonFormPageInit12_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormPageInit_if12 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_769408_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("1", "string"),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonFormPageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.IsDonus ?? this.props.screenInputs.isdonus,
        true
      )
    ) {
      isErrorOccurred = await this.RezervasyonFormPageInit_if12();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.isComp794779Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.taslakKaydet
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp940133Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.tamamla
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp448448Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.guncelle
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp388008Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.onayla
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp242250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.reddet
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp95703Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.iptal
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp172569Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.sil
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.rezervasyonform_949529_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.mudur
    );

    formVars.rezervasyonform_24225_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.asistan
    );

    formVars.rezervasyonform_422516_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.teknisyen
    );

    formVars.rezervasyonform_385661_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.yolcu
    );

    formVars.rezervasyonform_249814_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.pilot
    );

    stateVars.dataSource_322266 =
      stateVars.OnayDurumListe ?? this.state.OnayDurumListe;
    stateVars.dataSource_322266 =
      stateVars.OnayDurumListe ?? this.state.OnayDurumListe;

    stateVars.dataSource_577867 =
      stateVars.TalepEdenListeGetir ?? this.state.TalepEdenListeGetir;
    stateVars.dataSource_577867 =
      stateVars.TalepEdenListeGetir ?? this.state.TalepEdenListeGetir;
    stateVars.isComp577867Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.talepEden
        ),
        true
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_316044 =
      stateVars.UcusTipiListe ?? this.state.UcusTipiListe;
    stateVars.dataSource_316044 =
      stateVars.UcusTipiListe ?? this.state.UcusTipiListe;
    stateVars.isComp769408Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp907296Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp190170Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825552Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp989587Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_167735 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.dataSource_167735 = stateVars.UlkeListe ?? this.state.UlkeListe;

    stateVars.dataSource_284227 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.dataSource_284227 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.isComp107260Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.varisSaatVisible
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp844446Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp11679Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp641052Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;
    stateVars.isComp607211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_990298_value",
          "isManuel"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp100817Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_990298_value",
          "isManuel"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp127384Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp938114Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.yolcuEdit
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_316139 =
      stateVars.MurettebatListe ?? this.state.MurettebatListe;
    stateVars.dataSource_316139 =
      stateVars.MurettebatListe ?? this.state.MurettebatListe;

    stateVars.dataSource_412266 =
      stateVars.YazismaGetir ?? this.state.YazismaGetir;
    stateVars.isComp203119Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_412266_value",
          "isYolcu"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848871Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_412266_value",
          "isYolcu"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp808818Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_412266_value",
          "isYolcu"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp354518Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_412266_value",
          "isYolcu"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp141226Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.RezervasyonGorunumAyarla?.gonder
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonFormComponent_854746_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_162835_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      KalkisUlke_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      KalkisNokta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_459685_value",
            "value",
            "NoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        "string"
      ),
      KalkisSaat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_445833_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      KalkisTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_461957_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Murettebat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_316139_value",
            "value",
            "MurettebatListe",
            "adSoyad",
            "adSoyad"
          )
        ),
        "string"
      ),
      OnayDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_322266_value",
            "value",
            "OnayDurumListe",
            "durum",
            "durum"
          )
        ),
        "number"
      ),
      Onaylayan_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_792446_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TalepEden_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_577867_value",
            "value",
            "TalepEdenListeGetir",
            "eposta",
            "eposta"
          )
        ),
        "string"
      ),
      TekYonGidisDonus_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_769408_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      Ucak_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UcakListe !== undefined
            ? stateVars.UcakListe?.length > 0
              ? stateVars.UcakListe[0].ad
              : null
            : this.state.UcakListe?.length > 0
            ? this.state.UcakListe[0].ad
            : null
        ),
        "string"
      ),
      UcusTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_316044_value",
            "value",
            "UcusTipiListe",
            "no",
            "no"
          )
        ),
        "number"
      ),
      VarisUlke_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      VarisNokta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        "string"
      ),
      VarisSaat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_844446_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      GidisRezervasyonNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DonusRezervasyonNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_162835_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonKaydet = result?.data.rezervasyonKaydet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_162835_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.RezervasyonKaydet?.mesaj
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HATA", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "952287",
      null,
      null,
      "False",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_162835_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.RezervasyonKaydet?.durum),
        "2"
      )
    ) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_162835_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_162835_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.RezervasyonKaydet?.mesaj
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("UYARI", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "952287",
      null,
      null,
      "False",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_162835_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.RezervasyonKaydet?.durum),
        "1"
      )
    ) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_162835_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_162835_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.RezervasyonKaydet?.mesaj
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("BİLGİ", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.RezervasyonFormComponent_162835_onClick_if31_,
      "RezervasyonForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "952287",
      null,
      null,
      "False",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if3f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.AddToBag = await ReactSystemFunctions.addToBag(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string"),
      this.props.screenInputs.Id ?? this.props.screenInputs.id
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_162835_onClick_if3f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if3f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GetFromBag_GIDISREZID = await ReactSystemFunctions.getFromBag(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_162835_onClick_if31_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_769408_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "1"
      ) &&
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      ) &&
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "rezervasyonform_989587_value",
              "value",
              "",
              "",
              ""
            )
          ),
          true
        ))
    ) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_162835_onClick_if3f1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_162835_onClick_if32_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_162835_onClick_if32_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.RezervasyonKaydet?.durum),
        "0"
      )
    ) {
      if (await this.RezervasyonFormComponent_854746_onClick()) return true;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  RezervasyonFormComponent_162835_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.RezervasyonKaydet?.durum),
        "0"
      )
    ) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_162835_onClick_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_794779_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_940133_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_322266_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("1", "string"),
      null,
      "Durum"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_940133_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_940133_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_448448_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_388008_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_322266_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("2", "string"),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_792446_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );
    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_242250_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_322266_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_792446_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );
    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_95703_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "491ba718_022f_f00b_9610_cb03bac707e3_confirmation",
        this.defaultML,
        "Rezervasyonun iptal edileceğine emin misiniz?&nbsp;"
      ),
      "poppins",
      "Uyarı",
      "trash",
      "#ff2424"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonform_322266_value",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string"),
        null,
        "Durum"
      );
      if (await this.RezervasyonFormComponent_162835_onClick()) return true;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  RezervasyonFormComponent_172569_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "395eca61_0ff4_b193_7d72_ced4ff492340_confirmation",
        this.defaultML,
        "Rezervasyonun iptal edileceğine emin misiniz?&nbsp;"
      ),
      "poppins",
      "Uyarı",
      "trash",
      "#ff2424"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonform_322266_value",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string"),
        null,
        "Durum"
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_172569_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  RezervasyonFormComponent_172569_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.RezervasyonFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_211788_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_899034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "352231",
      null,
      "left",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_3760_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName("Fly.Rezervasyon", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.RezervasyonGetir !== undefined
            ? stateVars.RezervasyonGetir?.length > 0
              ? stateVars.RezervasyonGetir[0].ekleyen
              : null
            : this.state.RezervasyonGetir?.length > 0
            ? this.state.RezervasyonGetir[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.RezervasyonGetir !== undefined
            ? stateVars.RezervasyonGetir?.length > 0
              ? stateVars.RezervasyonGetir[0].degistiren
              : null
            : this.state.RezervasyonGetir?.length > 0
            ? this.state.RezervasyonGetir[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGetir !== undefined
            ? stateVars.RezervasyonGetir?.length > 0
              ? stateVars.RezervasyonGetir[0].eklemeZamani
              : null
            : this.state.RezervasyonGetir?.length > 0
            ? this.state.RezervasyonGetir[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.RezervasyonGetir !== undefined
            ? stateVars.RezervasyonGetir?.length > 0
              ? stateVars.RezervasyonGetir[0].degistirmeZamani
              : null
            : this.state.RezervasyonGetir?.length > 0
            ? this.state.RezervasyonGetir[0].degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "155526",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_769408_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp432393Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_769408_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_769408_onChange1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  RezervasyonFormComponent_769408_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_769408_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "0"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp432393Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("hidden", "string")
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  RezervasyonFormComponent_167735_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("%", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_167735_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NoktaListe = result?.data.noktaListe;

    formVars.rezervasyonform_459685_options = stateVars.NoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_167735_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_167735_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;
    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_459685_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_459685_value",
            "",
            "NoktaListe",
            "icaoCode",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_459685_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NoktaListe = result?.data.noktaListe;

    formVars.rezervasyonform_459685_options = stateVars.NoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_459685_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_459685_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;
    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_459685_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.RezervasyonFormComponent_461957_onChange()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_284227_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("%", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_284227_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VarisNoktaListe = result?.data.varisNoktaListe;

    formVars.rezervasyonform_554090_options = stateVars.VarisNoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_284227_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_284227_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;
    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_554090_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "",
            "VarisNoktaListe",
            "icaoCode",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_554090_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VarisNoktaListe = result?.data.varisNoktaListe;

    formVars.rezervasyonform_554090_options = stateVars.VarisNoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_554090_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_554090_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;
    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_554090_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_461957_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      LatitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "latitudeDeg"
          )
        ),
        "number"
      ),
      LongitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "longitudeDeg"
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_554090_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SunriseSunsetGetir = result?.data.sunriseSunsetGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_554090_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_554090_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_682208_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.SunriseSunsetGetir?.sunrise),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_891227_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.SunriseSunsetGetir?.sunset),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_461957_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_461957_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      LatitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_459685_value",
            "value",
            "NoktaListe",
            "icaoCode",
            "latitudeDeg"
          )
        ),
        "number"
      ),
      LongitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_459685_value",
            "value",
            "NoktaListe",
            "icaoCode",
            "longitudeDeg"
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_461957_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SunriseSunsetGetir = result?.data.sunriseSunsetGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_461957_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_461957_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_863315_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.SunriseSunsetGetir?.sunrise),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_458347_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.SunriseSunsetGetir?.sunset),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_461957_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonFormComponent_461957_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_461957_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      LatitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "latitudeDeg"
          )
        ),
        "number"
      ),
      LongitudeDeg_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "longitudeDeg"
          )
        ),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "RezervasyonForm/RezervasyonFormComponent_461957_onChange2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SunriseSunsetGetir = result?.data.sunriseSunsetGetir;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_461957_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_461957_onChange3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_461957_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonform_682208_value",
          "string"
        ),
        ReactSystemFunctions.value(
          this,
          this.state.SunriseSunsetGetir?.sunrise
        ),
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_461957_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_461957_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  RezervasyonFormComponent_461957_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonform_891227_value",
          "string"
        ),
        ReactSystemFunctions.value(this, this.state.SunriseSunsetGetir?.sunset),
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  RezervasyonFormComponent_641052_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.RezervasyonFormComponent_641052_onClick1_,
      "RezervasyonForm",
      "YolcuForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "595964",
      null,
      null,
      "False",
      "800px",
      "80vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  RezervasyonFormComponent_641052_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_641052_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_641052_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_641052_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_127384_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "rezervasyonform_990298_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.RezervasyonFormComponent_127384_onClick1_,
      "RezervasyonForm",
      "YolcuForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "833334",
      null,
      null,
      "False",
      "800px",
      "80vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  RezervasyonFormComponent_127384_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_127384_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    stateVars.YolcuTmpAdSoyadlar = result?.data.yolcuTmpAdSoyadlar;
    stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_127384_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_127384_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_938114_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "rezervasyonform_990298_value", "id"),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f36f212e_8a4e_2148_7b55_dbb558cf4083_confirmation",
        this.defaultML,
        "Silmek istediğinize emin misiniz?"
      ),
      "poppins",
      "Uyarı",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "RezervasyonForm/RezervasyonFormComponent_938114_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YolcuTmpSil = result?.data.yolcuTmpSil;
      stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

      stateVars.YolcuTmpAdSoyadlar = result?.data.yolcuTmpAdSoyadlar;
      stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.RezervasyonFormComponent_938114_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_938114_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_631587_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "rezervasyonform_755702_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Mesaj giriniz...",
      formName: "rezervasyonform_755702_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      IslemRUMB_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("R", "string"),
        "string"
      ),
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Metin_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_755702_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_631587_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaEkle = result?.data.yazismaEkle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_631587_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_631587_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HATA", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "78493",
      null,
      null,
      "true",
      "500px",
      "250px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_631587_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonForm/RezervasyonFormComponent_631587_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonFormComponent_631587_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonFormComponent_631587_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonform_755702_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_631587_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        ""
      )
    ) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_631587_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.RezervasyonFormComponent_631587_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_825552_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp907296Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825552Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_989587_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp190170Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp989587Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_989587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonFormComponent_249814_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp844446Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp11679Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonform_249814_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 352231] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.RezervasyonFormPageInit();
    }
    if (diId == 952287) {
      isErrorOccurred =
        await this.RezervasyonFormComponent_162835_onClick_if31_();
      if (isErrorOccurred) return true;
    } else if (diId == 595964) {
      isErrorOccurred = await this.RezervasyonFormComponent_641052_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 833334) {
      isErrorOccurred = await this.RezervasyonFormComponent_127384_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
